import { useMemo } from "react";
import Review from "src/components/Review";
import { reviews } from "src/constants/reviews";
import { usePatient } from "src/context/PatientProvider";
import { useProduct } from "src/context/ProductProvider";
import Carousel from "src/shared/components/Carousel";

interface Props {
  onFocus: (v: string) => void;
}

const ReviewsCarousel = ({ onFocus }: Props) => {
  const gender = usePatient((p) => p.profile.gender);
  const productSlug = useProduct((p) => p.slug);

  const reviewsByGender = useMemo(() => {
    const finaleReviews = reviews.filter((r) =>
      r.product?.includes(productSlug),
    );

    if (!gender) return finaleReviews;

    return finaleReviews.filter((r) => r.gender === gender.toLowerCase());
  }, [gender, productSlug]);

  if (reviewsByGender.length === 0) {
    return null;
  }

  return (
    <Carousel
      onFocus={() => onFocus("payment-input")}
      length={reviewsByGender.length}
    >
      {reviewsByGender.map((review) => (
        <Review review={review} width="575px" key={review.id} />
      ))}
    </Carousel>
  );
};

export default ReviewsCarousel;
